export interface PlpDomainData {
	item_list_name: string
	item_list_id: string
}

export interface PdpDomainData {
	page_title: string
}

export const withItemListDomainData = (
	domainData: PlpDomainData | PdpDomainData | undefined
): domainData is PlpDomainData => {
	return (domainData as PlpDomainData)?.item_list_id !== undefined
}
